import { render, staticRenderFns } from "./WorkPlaceEdit.vue?vue&type=template&id=f9e3169a"
import script from "./WorkPlaceEdit.vue?vue&type=script&lang=js"
export * from "./WorkPlaceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports